import {type QuotaKeys} from '@pinecone-experience/commons/quotas';
import {createReducer, isAnyOf} from '@reduxjs/toolkit';
import {
  getOrganizationQuotaUtilizationFailure,
  getOrganizationQuotaUtilizationRequest,
  getOrganizationQuotaUtilizationSuccess,
} from '../actions/quotaActions';

interface OrganizationState {
  loading: boolean;
  quotaUtilization: Record<QuotaKeys, number>;
}

const initialOrganizationState = {
  loading: true,
  quotaUtilization: {},
} as OrganizationState;

export interface QuotaUtilizationState {
  organizations: Record<string, OrganizationState>;
}

const initialState = {
  organizations: {},
} as QuotaUtilizationState;

const organizationReducer = createReducer(initialOrganizationState, (builder) => {
  builder
    .addCase(getOrganizationQuotaUtilizationRequest, (state) => {
      state.loading = true;
    })
    .addCase(getOrganizationQuotaUtilizationSuccess, (state, action) => {
      state.quotaUtilization = action.payload.quotaUtilization;
      state.loading = false;
    })
    .addCase(getOrganizationQuotaUtilizationFailure, (state) => {
      state.loading = false;
    });
});

const quotaUtilizationReducer = createReducer(initialState, (builder) => {
  builder.addMatcher(
    isAnyOf(
      getOrganizationQuotaUtilizationFailure,
      getOrganizationQuotaUtilizationRequest,
      getOrganizationQuotaUtilizationSuccess,
    ),
    (state, action) => {
      state.organizations[action.payload.organizationId] = organizationReducer(
        state.organizations[action.payload.organizationId],
        action,
      );
    },
  );
});

export default quotaUtilizationReducer;
